import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { UtilService } from '../services/util.service';
import { ErrorLogService } from '../services/error-log.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(
		@Inject(PLATFORM_ID) public platformId: Object,
		public authService : AuthService,
		public utilService : UtilService,
		public errorLog: ErrorLogService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(catchError(err => {
			this.errorLog.handleError(new Error(JSON.stringify({response:err,request})), 'http');			
			if (err.status === 401) {
				// 401 = expired/invalid token. With live-token + autoRenew this is rare; when it
				// does happen the session is genuinely dead, so send the user back through sign-in
				// to mint a fresh token instead of leaving the UI stuck on a dead token.
				if (!request.url.includes('authenticate') && !request.url.includes('validateToken')) {
					this.utilService.openSnackBar('Your session has expired. Signing you in again…');
					this.authService.logout();
				}
			} else if (err.status === 403) {
				// 403 = authenticated but not permitted; not a token problem — do NOT sign out.
				this.utilService.openSnackBar('You do not have permission to perform this action.');
			} else {
				this.utilService.openSnackBar(typeof err.error == 'string' ? err.error : err.message);
			}
			return throwError(err);
		}))
	}
}